import React from 'react'
import ToDo from './ToDo'
import { TodoContextProvider } from '../context/TodoContext'

const ToDoHome = () => {
    return (
        <>
            <TodoContextProvider>
                <ToDo />
            </TodoContextProvider>

        </>
    )
}

export default ToDoHome